import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", y = 28 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.7, delay, ease: [0.16, 1, 0.3, 1] }}
  >
    {children}
  </motion.div>
);

export const SectionHeading = ({ overline, title, lead, align = "left" }) => (
  <Reveal
    className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""}`}
  >
    <p className="font-tech text-xs uppercase tracking-[0.3em] text-amber-400 font-semibold mb-4">
      {overline}
    </p>
    <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-zinc-100 leading-[1.1]">
      {title}
    </h2>
    {lead && (
      <p className="mt-5 text-base sm:text-lg text-zinc-400 leading-relaxed">
        {lead}
      </p>
    )}
  </Reveal>
);
